var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    _vm._g(
      _vm._b(
        {
          staticClass: "jade-link",
          class: _vm.computedClass,
          attrs: { role: "link" },
        },
        "a",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.icon
        ? _c("jade-icon", {
            attrs: {
              use: _vm.icon,
              "aria-hidden": "",
              size: "small",
              color: _vm.computedIconColor,
            },
          })
        : _vm._e(),
      _c(
        "jade-text",
        {
          attrs: {
            weight: "medium",
            variant: _vm.computedText,
            color: "current-color",
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm.external
        ? _c("jade-icon", {
            attrs: {
              "aria-hidden": "",
              use: "arrow-north-east",
              size: "small",
              color: _vm.computedIconColor,
              "data-testid": "external-icon",
            },
          })
        : _c("jade-icon", {
            attrs: {
              "aria-hidden": "",
              use: "chevron-right",
              size: "small",
              color: _vm.computedIconColor,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }